//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../../lib/date';

export default {
    name: 'owner-baseinfo',
    props: {
        ownerInfo: {
            type: Object,
            required: true
        }
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            loading: false,
            // ownerInfo: {
            //     room: {}
            // },
            saving: false
        };
    },
    methods: {
        getOwnerById() {
            if (this.id === 0) {
                return;
            }
            const vm = this;
            vm.loading = true;
            abp.ajax
                .get('/api/services/app/Owner/GetOwnerById?id=' + this.id)
                .then(res => {
                    vm.ownerInfo = {
                        room: {}
                    };
                    vm.ownerInfo = res.data.result;
                    vm.loading = false;
                })
                .finally(() => {
                    vm.loading = false;
                });
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        // this.getOwnerById();
    },
    watch: {}
};
